module.exports = "https://bicocca-network.servercdn.it/static/img/FuturaPT-Heavy.svg?b427abb8757d10d0fd1ce7bef19e5bc2";